// extracted by mini-css-extract-plugin
export default {"tupacGrid":"rj-z","tupacHeader":"sj-z","tupacHeader2":"tj-z","tupacMenu":"uj-z","tupacMenu2":"vj-z","tupacMain":"wj-z","tupacMain2":"xj-z"};